// extracted by mini-css-extract-plugin
export default {"table-container":"nZNrC1O9RM9G9vVaCeN9","top-right-field":"LnlG2k0odOJKTOCrhcKJ","table-wrapper":"XEZpZjx8p2C_RgrYfuYJ"};